import { useEffect } from 'react';
import { SessionRail } from './SessionRail';
import { HeaderBar } from './HeaderBar';
import { InspectorPanel } from './InspectorPanel';
import { MessageThread } from '../thread/MessageThread';
import { Composer } from '../composer/Composer';
import { ApprovalDialog } from '../thread/ApprovalDialog';
import { SettingsDialog } from '../settings/SettingsDialog';
import { useActiveSession } from '@/hooks/useActiveSession';
import { useModeShortcuts } from '@/hooks/useModeShortcuts';
import { isEmbedded } from '@/lib/embed';
import { useUIStore } from '@/lib/store/uiStore';

export function WorkspaceShell() {
  const session = useActiveSession();
  useModeShortcuts();

  // When embedded, force rails closed on first mount — overrides any
  // persisted "open" state from a prior standalone session. The user can
  // still toggle them via Ctrl+B / Ctrl+\ if they want.
  useEffect(() => {
    if (!isEmbedded) return;
    const s = useUIStore.getState();
    if (s.railOpen) s.setRailOpen(false);
    if (s.inspectorOpen) s.setInspectorOpen(false);
  }, []);

  return (
    <div className="flex h-screen w-screen overflow-hidden bg-canvas">
      <SessionRail />
      <main className="flex min-w-0 flex-1 flex-col">
        {!isEmbedded && <HeaderBar session={session} />}
        <div className="min-h-0 flex-1">
          {session ? (
            <MessageThread session={session} />
          ) : (
            <div className="flex h-full items-center justify-center text-sm text-fg-subtle">
              No session selected.
            </div>
          )}
        </div>
        <Composer session={session} />
      </main>
      <InspectorPanel />
      <ApprovalDialog />
      <SettingsDialog />
    </div>
  );
}
